import { Staff } from '@/models/api/Data/staff';
import Equipment from '@/models/client/equipment';
import ClientTaskModel from '@/models/client/client-task';
import ClientRowModel from '@/models/client/client-row';
import { LevelledResourceViewModel, LocationModel, ShiftHazardNoteViewModel } from '@/models/api';

export enum DropTargetType {
    ROLE = 'role',
    EQUIPMENT = 'equipment',
    TASK = 'task',
    LOCATION = 'location',
}

export enum DragSourceType {
    EQUIPMENT = 'equipment',
    STAFF = 'staff'
}

export interface DraggedStaff {
    type: 'staff';
    staff: Staff;
}

export interface DraggedEquipment {
    type: 'equipment';
    equipment: Equipment;
}

export type StaffInfo = Staff & { levelledResource: LevelledResourceViewModel | null };
export type DragItem = DraggedEquipment | DraggedStaff;
export type EquipmentInfo = Equipment & { secondaryEquipment: Equipment[]; staff: Staff[]; tasks: ClientTaskModel[] };
export type TaskInfo = ClientTaskModel & { staff: Staff[]; };
export type ResourceEnabledTaskInfo = ClientTaskModel & { staff: StaffInfo[], levelledResource: LevelledResourceViewModel | null };
export type LocationInfo = LocationModel & { plannedLocationId: string, tasks: TaskInfo[]; };
export type ResourceEnabledLocationInfo = LocationModel & { hazards: ShiftHazardNoteViewModel[]; comments: string | null; plannedLocationId: string, tasks: ResourceEnabledTaskInfo[]; };